<template>
  <div class="gwd-table-row">
    <span class="flex">{{ cost.name }}</span>
    <span class="flex">{{ cost.amount }} {{ cost.unit }}</span>
  </div>
</template>

<script>
export default {
  name: "CompactWorkerCost",
  props: {
    cost: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss"></style>
